<!-- Date Disponibili -->
<ng-container *ngIf="this.cruiseDetail?.solutions?.length">

  <h4 class="detail-section__title">Date disponibili</h4>

  <div class="row-icon mb-2">
    <div class="row-icon__icon">
      <i class="icon-calendar"></i>
    </div>
    <div class="row-icon__text" *ngIf="this.cruiseDetail?.solutions?.length === 1">
      Abbiamo trovato 1 data di partenza disponibile
    </div>
    <div class="row-icon__text" *ngIf="this.cruiseDetail?.solutions?.length > 1">
      Abbiamo trovato {{this.cruiseDetail?.solutions?.length}} date di partenza disponibili
    </div>
  </div>

  <div class="date-calendar">
    <swiper [config]="config"
            [(index)]="index" class="pagination date-calendar_bar">
      <div class="page-item date-calendar_bar-item"
           [ngClass]="{'active': (solution.departureDate | dayjs : 'MMMDD') === (selectedSolution?.departureDate | dayjs : 'MMMDD')}"
           *ngFor="let solution of this.cruiseDetail?.solutions | orderBy: 'departureDate'">
        <a class="page-link date-calendar_bar-link" (click)="this.selectSolution(solution)">
          <span class="date-calendar_bar-link-day">{{solution.departureDate | dayjs: 'dddd'}}</span>
          <span class="date-calendar_bar-link-date">
                  <span class="date-calendar_bar-link-date-number">{{solution.departureDate | dayjs: 'DD'}}</span>
                  <span class="date-calendar_bar-link-date-month">
                    <span>{{solution.departureDate | dayjs: 'MMM'}}</span>
                    <span>{{solution.departureDate | dayjs: 'YYYY'}}</span>
                  </span>
                </span>
        </a>
      </div>
    </swiper>
  </div>
</ng-container>
